import React from 'react';
import { IconButton } from '../IconButton/IconButton';
import { Segmented } from '../Segmented/Segmented';
import type { CalendarView } from '../../calendar/types';

export interface CalendarPageNavProps {
  view: CalendarView;
  onViewChange: (view: CalendarView) => void;
  onPrev?: () => void;
  onNext?: () => void;
  onToday?: () => void;
}

export function CalendarPageNav({ view, onViewChange, onPrev, onNext, onToday }: CalendarPageNavProps) {
  const isWeek = view === 'Week';
  const prevLabel = isWeek ? 'Previous week' : view === 'Month' ? 'Previous month' : 'Previous day';
  const nextLabel = isWeek ? 'Next week' : view === 'Month' ? 'Next month' : 'Next day';
  const todayLabel = isWeek ? 'This week' : view === 'Month' ? 'This month' : 'Today';

  return (
    <div className="flex shrink-0 flex-wrap items-center gap-1">
      <IconButton icon="left" size={36} label={prevLabel} onClick={onPrev} className="glass-control glass-control--sm" />
      <IconButton icon="right" size={36} label={nextLabel} onClick={onNext} className="glass-control glass-control--sm" />
      <button
        type="button"
        onClick={onToday}
        className="glass-control h-9 cursor-pointer rounded-[var(--r-pill)] border px-4 font-[var(--font-body)] text-[13px] font-semibold"
      >
        {todayLabel}
      </button>
      <Segmented
        glossy
        options={['Day', 'Week', 'Month']}
        value={view}
        onChange={(v) => {
          onViewChange(v as CalendarView);
        }}
      />
    </div>
  );
}
